import { generatePath, Navigate, useParams } from "react-router-dom";

/**
 * Navigates to a route template, filling it with the current route's params.
 * Used by `index` and catch-all routes that redirect to a feature's default tab.
 */
export default function RedirectToRoute({ route }: { route: string }) {
  const params = useParams();
  return <Navigate to={generatePath(route, params)} replace />;
}
